<header>
  <img src="/images/trello-logo.svg" alt="Trello" class="logo" />
</header>

<style lang="scss">
  header {
    height: 40px;
    background-color: rgba(black, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;

    img.logo {
      width: 80px;
      opacity: 0.6;
    }
  }
</style>
